import { createWidgetRootRoute } from "@blockdaemon/widget-host";
import type { ReactNode } from "react";

import { TokenizationLocaleConfigWrapper } from "../lib/i18n/tokenization-locale-config-wrapper";
import { TokenizationWidgetConfigProvider } from "../providers/tokenization-widget-config-provider";

// TokenizationWidgetConfigProvider is intentionally omitted here: in showcase mode the
// config provider is injected externally by PRODUCT_REGISTRY (via ConfigProvider in
// widget-product-registry.tsx), so it must not be mounted again inside the route tree.
function TokenizationShowcaseWrapper({ children }: { children: ReactNode }) {
  return <TokenizationLocaleConfigWrapper>{children}</TokenizationLocaleConfigWrapper>;
}

function TokenizationStandaloneWrapper({ children }: { children: ReactNode }) {
  return (
    <TokenizationWidgetConfigProvider>
      <TokenizationLocaleConfigWrapper>{children}</TokenizationLocaleConfigWrapper>
    </TokenizationWidgetConfigProvider>
  );
}

export const Route = createWidgetRootRoute({
  ShowcaseWrapper: TokenizationShowcaseWrapper,
  StandaloneWrapper: TokenizationStandaloneWrapper,
});
